import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import  { Volantini } from '../_models/volantini.model'
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
  })

export class VolantiniService{
/*     private availableVolantini:Volantini[] = [
        {id: "1",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "2",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "3",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "4",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "5",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "6",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "7",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "8",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "1",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "2",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "3",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "4",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "5",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "6",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "7",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},
        {id: "8",dataInizio:new Date(2021-11-10),dataFine:new Date(2021-12-10) ,descrizione: "è molto bello"},

    ];

    getAvailableVolantini(){
        return this.availableVolantini.slice();
    } */

    private volantiniListEndPoint ="B2C/Volantini/GetAll";

    private volantini: ReplaySubject<Volantini[]>;
    public volantini$: Observable<Volantini[]>;

    constructor(private baseService: BaseService){
        this.volantini = new ReplaySubject<Volantini[]>(1)
        this.volantini.next([]);
        this.volantini$ = this.volantini.asObservable();
    }

    public refreshList(){
        return this.baseService.getOnce<Volantini[]>(this.volantiniListEndPoint, (data: Volantini[]) => {
            this.volantini.next(data);
        })
    }
}